import { render, staticRenderFns } from "./DetailNews.vue?vue&type=template&id=1690cab0&scoped=true&"
import script from "./DetailNews.vue?vue&type=script&lang=js&"
export * from "./DetailNews.vue?vue&type=script&lang=js&"
import style0 from "./DetailNews.vue?vue&type=style&index=0&id=1690cab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690cab0",
  null
  
)

export default component.exports